'use client'

import { createIcon } from '@chakra-ui/icons'

export default createIcon({
  displayName: 'ChevronRight',
  viewBox: '0 0 24 24',
  d: 'M18 12C18 12.3 17.9091 12.5 17.7273 12.7L9.54545 21.7C9.18182 22.1 8.63636 22.1 8.27273 21.7C7.90909 21.3 7.90909 20.7 8.27273 20.3L15.8182 12L8.27273 3.7C7.90909 3.3 7.90909 2.7 8.27273 2.3C8.63636 1.9 9.18182 1.9 9.54545 2.3L17.7273 11.3C17.9091 11.5 18 11.8 18 12Z',
})
